const XIcon = ({ className, fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.97945 2.9797C3.17472 2.78444 3.4913 2.78444 3.68656 2.9797L7.99967 7.29281L12.3128 2.9797C12.508 2.78444 12.8246 2.78444 13.0199 2.9797C13.2152 3.17496 13.2152 3.49154 13.0199 3.68681L8.70678 7.99992L13.0199 12.313C13.2152 12.5083 13.2152 12.8249 13.0199 13.0201C12.8246 13.2154 12.508 13.2154 12.3128 13.0201L7.99967 8.70702L3.68656 13.0201C3.4913 13.2154 3.17472 13.2154 2.97945 13.0201C2.78419 12.8249 2.78419 12.5083 2.97945 12.313L7.29257 7.99992L2.97945 3.68681C2.78419 3.49154 2.78419 3.17496 2.97945 2.9797Z"
        fill={fill || "white"}
      />
    </svg>
  );
};

export default XIcon;
